import React from "react";
import type { ChangeEventHandler, MouseEventHandler } from "react";
import classnames from "classnames";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Label,
  FormGroup,
  InputGroup,
  Input,
} from "reactstrap";
import SimpleHeader from "@/components/Headers/SimpleHeader";
import ImageUploadContainer from "../User/adding-user/ImageUploadContainer";
import BlockContentArrayContainer from "../PagesComponent/UpdatePage/BlockContentArrayContainer";
import BylinePeopleFields from "./BylinePeopleFields";
import type { SitePermission } from "@/services/userServices/useCurrentPermission";

type CreatePostViewProps = {
  permission: SitePermission;

  title: string;
  type: boolean;
  validation: { title: boolean; content: boolean };
  reactQuillText: string;
  reset: boolean;
  // BlockContentArrayContainer.jsx defaults `blocks = []`, which checkJs infers as
  // never[]: no typed array is assignable to it until that file is converted.
  blocks: any;
  data: unknown;
  editor: string | null;
  reviewer: string | null;

  onChange: ChangeEventHandler<HTMLInputElement>;
  onEditorChange: (id: string | null) => void;
  onReviewerChange: (id: string | null) => void;
  onChangeToggle: ChangeEventHandler<HTMLInputElement>;
  handleReactQuillChange: (value: string) => void;
  ImageUploadRecievedHandler: (img: unknown) => void;
  handleAdd: (blocks: Record<string, unknown>[]) => void;
  handleDelete: (blocks: Record<string, unknown>[]) => void;
  handleBlockArray: (blocks: Record<string, unknown>[]) => Promise<void>;
  onSubmit: MouseEventHandler<HTMLButtonElement>;
};

const CreatePostView = ({

  permission,

  title,
  type,
  validation,
  reactQuillText,
  reset,
  blocks,
  data,
  editor,
  reviewer,

  onChange,
  onEditorChange,
  onReviewerChange,
  onChangeToggle,
  handleReactQuillChange,
  ImageUploadRecievedHandler,
  handleAdd,
  handleDelete,
  handleBlockArray,
  onSubmit,
}: CreatePostViewProps) => {
  return (
    <>
      <SimpleHeader name="Manage Posts " parentName="Global Tools " />

      {permission?.publish || permission?.edit ? (
        <Container className="mt--6" fluid>
          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h5 className="h3 mb-0">Add Post</h5>
                    </Col>
                  </Row>
                </CardHeader>

                <CardBody>
                  <Row className="mr-3 ml-2">
                    <Col>
                      {/* Post Type switch */}
                      <FormGroup className="row">
                        <Label className="form-control-label" md="2">
                          Post Type
                        </Label>
                        <Col md="1">
                          <label className="custom-toggle custom-toggle-danger mr-1">
                            <input
                              onChange={onChangeToggle}
                              name="type"
                              type="checkbox"
                              checked={!!type}
                            />
                            <span
                              className="custom-toggle-slider rounded-circle"
                              data-label-off="POST"
                              data-label-on="NEWS"
                            />
                          </label>
                        </Col>
                      </FormGroup>

                      {/* Title */}
                      <FormGroup className="row">
                        <Label className="form-control-label" md="2">
                          Post Title
                        </Label>
                        <Col md="6">
                          <InputGroup className={classnames("input-group-merge")}>
                            <Input
                              placeholder="Insert Post Title"
                              name="title"
                              type="text"
                              value={title}
                              onChange={onChange}
                              invalid={!validation.title}
                            />
                          </InputGroup>
                          {!validation.title ? (
                            <InputGroup className="invalid-feedback">
                              Required State.
                            </InputGroup>
                          ) : null}
                        </Col>
                      </FormGroup>

                      {/* Editor and reviewer (SCRUM-1918) */}
                      <BylinePeopleFields
                        editor={editor}
                        reviewer={reviewer}
                        onEditorChange={onEditorChange}
                        onReviewerChange={onReviewerChange}
                      />

                      {/* Picture */}
                      <FormGroup className="row">
                        <Label className="form-control-label" md="2">
                          Picture
                        </Label>
                        <Col md="7">
                          <Row className="text-center">
                            <Col>
                              <ImageUploadContainer ImageUpload={ImageUploadRecievedHandler} withContext />
                            </Col>
                          </Row>
                        </Col>
                      </FormGroup>

                      {/* Content */}
                      <FormGroup className="row" lg="11">
                        <Label className="form-control-label" md="2">
                          Content
                        </Label>
                        <Col>
                          <ReactQuill
                            value={reactQuillText}
                            onChange={handleReactQuillChange}
                            theme="snow"
                            modules={{
                              toolbar: [
                                ["bold", "italic"],
                                ["link", "blockquote", "code"],
                                [{ list: "ordered" }, { list: "bullet" }],
                              ],
                            }}
                          />
                          {!validation.content ? (
                            <InputGroup className="invalid-feedback">
                              Required State.
                            </InputGroup>
                          ) : null}
                        </Col>
                      </FormGroup>

                      {/* Blocks */}
                      <div> testttt 
                      <FormGroup className="row" lg="11">
                        <Col>
                          <BlockContentArrayContainer
                            data={data}
                            blocks={blocks}
                            isRequired={false}
                            add={handleAdd}
                            delete={handleDelete}
                            handleBlockArray={handleBlockArray}
                            reset={reset}
                          />
                        </Col>
                      </FormGroup>
                      </div>

                      {/* Submit */}
                      <FormGroup className="row">
                        <Col md="12">
                          <Col className="text-right">
                            <Button className="my-4" color="primary" type="button" onClick={onSubmit}>
                              Add
                            </Button>
                          </Col>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      ) : null}
    </>
  );
};

export default CreatePostView;
